import React from "react";
import "./PalliativeCareArticles.css"; // We'll create this CSS file next
import MyFooter from "./MyFooter";
import PdfViewer from "./PdfViewer";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";


const PalliativeCareArticles = () => {
  const { language } = useLanguage();
  // Sample palliative care article data
  const articles = [
    {
      id: 1,
      title: "പാലിയേറ്റീവ് പരിചരണം - ചരിത്രവും ദര്‍ശനവും",
      excerpt:
        "മനുഷ്യ സമൂഹത്തിന്‍റെ ആവിര്‍ഭാവം മുതലേ അവന്‍ സഹജീവികളോട് അനുതാപവും ആര്‍ദ്രതയും പ്രകടിപ്പിച്ചിരുന്നു.",
      imageUrl: "https://picsum.photos/id/301/800/400", // Doctor with patient
      date: "June 10, 2025",
      author: "ഇ.അബ്ദുല്‍ മജീദ്",
      category: "Palliative",
      fname: "history.pdf",
    },
    {
      id: 2,
      title: "ജനകീയ പാലിയേറ്റീവ് പരിചരണ നയം ",
      excerpt:
        "കേരളത്തിൽ പാലിയേറ്റീവ് കെയർ പ്രവർത്തനങ്ങൾ ആരംഭിച്ചിട്ട് മൂന്നു പതിറ്റാണ്ടിനടുത്തായി.",
      imageUrl: "https://picsum.photos/id/305/800/400", // Medical professional
      date: "May 25, 2025",
      author: "അലി പത്തനാപുരം, ഇ.അബ്ദുല്‍മജീദ്",
      category: "Treatment",
      fname: "palliative.pdf",
    },
    {
      id: 3,
      title: "സാന്ത്വനമേകുന്ന അയല്പക്കമാവുക",
      excerpt:
        "ഇന്ന് സാമൂഹിക പ്രവർത്തന മേഖലയിൽ ചൂണ്ടികാണിക്കാവുന്ന",
      imageUrl: "https://picsum.photos/id/309/800/400", // Medical professional
      date: "Jul 10, 2025",
      author: "ശബാബ് വീക്കിലി (കടപ്പാട്)",
      category: "Palliative",
      fname: "article3.pdf",
    },



 {
      id: 4,
      title: "രോഗികളും കൂട്ടിരിപ്പുകാരും പരിചരണമർഹിക്കുന്നു ",
      excerpt:
        "ജീവിതത്തെ ദുരിതത്തിലാക്കും വിധം ഗുരുതര രോഗപീഢ",
      imageUrl: "https://picsum.photos/id/306/800/400", // Medical professional
      date: "Jul 10, 2025",
      author: "ശബാബ് വീക്കിലി (കടപ്പാട്)",
      category: "Palliative",
      fname: "article4.pdf",
    },

  ];

  return (
    <div data-aos="fade-up">
      <div className="palliative-care-articles">
        <header className="page-header">
          <h1>{language === "en" ? "Articles" : "ലേഖനങ്ങൾ"}</h1>
          <p>{language === "en" ? "Compassionate information and support for patients and families" : "രോഗികൾക്കും കുടുംബങ്ങൾക്കുമുള്ള വിവരങ്ങളും പിന്തുണയും"}</p>
        </header>

        <div className="articles-container">
          {articles.map((article) => (
            <article key={article.id} className="article-card">
              <div className="article-image">
                <img src={article.imageUrl} alt={article.title} />
                <span className="article-category">{article.category}</span>
              </div>
              <div className="article-content">
                <h2>{article.title}</h2>
                <p className="article-meta">
                  By {article.author} • {article.date}
                </p>
                <p className="article-excerpt">{article.excerpt}</p>
                <Link to={`/pdfviewer/${encodeURIComponent(article.fname)}`}>
                  <button className="read-more-btn">{language === "en" ? "Read Article" : "ലേഖനം വായിക്കുക"}</button>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PalliativeCareArticles;
